import styled, { css, createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
${({ theme }) => css`
  * {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    background: ${theme.colors.gray.extraLight};
    color: ${theme.colors.gray.normal};
    font-family: Open Sans, sans-serif;
    font-size: 1rem;
    font-weight: normal;
    line-height: 1.5;

    textarea {
      line-height: inherit;
    }

    input[type='button'],
    input[type='reset'],
    input[type='submit'] {
      cursor: pointer;
    }

    input,
    optgroup,
    select,
    textarea {
      font-family: inherit;
    }

    p {
      display: block;
      margin-top: 0;
      margin-bottom: 1rem;
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;
    }

    iframe {
      border: 0;
    }

    h3 {
      display: block;
      font-weight: 100;
      font-family: 'Open Sans', sans-serif;
      color: ${theme.colors.gray.normal};
      margin: 10px 0;
    }

    h3,
    .h3 {
      font-size: 22px;
      line-height: 28px;
    }
  }
`}

`;

export const MainLayoutContent = styled.div`
  ${({ show, theme }) =>
    show &&
    css`
      flex: 1;
      padding: 70px 15px 10px;

      @media (min-width: 1450px) {
        max-width: 83%;
        margin: auto;
      }

      @media (max-width: ${theme.sizes.mobile}) {
        padding-bottom: 40px;
      }
    `}
`;
